import React from "react";
import { motion } from "framer-motion";

export default function TranscriptionTimelineItem({ transcript, darkMode }) {
  const isPerson1 = transcript?.personIs === "Person 1";

  return (
    <motion.div
      className={`flex items-end gap-1.5 ${
        isPerson1 ? "flex-row" : "flex-row-reverse"
      }`}
      initial={{ y: 16, opacity: 0, scale: 0.92 }}
      animate={{ y: 0, opacity: 1, scale: 1 }}
      transition={{ ease: "easeOut", duration: 0.25 }}
    >
      {/* Timestamp */}
      <span
        className={`text-[10px] shrink-0 mb-0.5 ${
          darkMode ? "text-gray-500" : "text-gray-400"
        }`}
      >
        {transcript?.timeSpokenAt}
      </span>

      {/* Bubble */}
      <div
        className={`flex flex-col gap-0.5 max-w-full ${
          isPerson1 ? "items-start" : "items-end"
        }`}
      >
        {/* Label */}
        <span
          className={`text-[10px] font-medium leading-none ${
            darkMode ? "text-gray-400" : "text-gray-500"
          }`}
        >
          {transcript?.personIs}
        </span>

        {/* Message */}
        <div
          className={`rounded-xl px-2.5 py-1.5 text-xs leading-snug ${
            isPerson1
              ? darkMode
                ? "bg-gray-700 text-gray-100 rounded-tl-sm"
                : "bg-gray-100 text-gray-900 rounded-tl-sm"
              : darkMode
                ? "bg-blue-600 text-white rounded-tr-sm"
                : "bg-blue-500 text-white rounded-tr-sm"
          }`}
        >
          {transcript?.speech}
        </div>
      </div>
    </motion.div>
  );
}
